import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import React, { useEffect, useReducer } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { useMountEffect } from '../../../hooks';
import Notification from '../../elementals/notification';
import styles from './styles.scss';
const cx = classnames.bind(styles);
const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
const CLOSE_NOTIFICATION = 'CLOSE_NOTIFICATION';
const setClosingTimeout = notification => ({
    ...notification,
    timeoutId: setTimeout(notification.onClose, 5000),
});
const initState = notifications => notifications.map(setClosingTimeout);
const reducer = (state, action) => {
    switch (action.type) {
        case ADD_NOTIFICATION:
            return action.notifications.map((notification, id) => state[id] || setClosingTimeout(notification));
        case CLOSE_NOTIFICATION:
            return state.map(toastMessage => {
                if (toastMessage.id !== action.id) {
                    return toastMessage;
                }
                clearTimeout(toastMessage.timeoutId);
                return {
                    ...toastMessage,
                    isVisible: false,
                };
            });
        default:
            throw new Error('Not a valid action');
    }
};
const Notifier = ({ notifications = [], onUnmount, position = 'top' }) => {
    const closeNotification = id => () => {
        dispatch({
            type: CLOSE_NOTIFICATION,
            id,
        });
    };
    const formatMessage = (notification, id) => ({
        ...notification,
        id,
        isVisible: true,
        onClose: closeNotification(id),
    });
    const [formatedNotifications, dispatch] = useReducer(reducer, notifications.map(formatMessage), initState);
    useEffect(() => {
        const formatedNotifications = notifications.map(formatMessage);
        dispatch({
            type: ADD_NOTIFICATION,
            notifications: formatedNotifications,
        });
    }, [notifications]);
    useMountEffect(() => onUnmount);
    return (_jsx("div", { className: cx('container', position), children: formatedNotifications.map(formatedNotification => (_createElement(Notification, { ...formatedNotification, key: formatedNotification.id, isAnimated: true }))) }));
};
Notifier.propTypes = {
    notifications: PropTypes.array,
    onUnmount: PropTypes.func,
    position: PropTypes.oneOf(['top', 'bottom']),
};
export default Notifier;
//# sourceMappingURL=index.js.map